import statuses from '@/helpers/statuses'

const initialState = () => ({
  me: null,
  profiles: {},
  thanks: {},
  meta: {
    thanksLoading: statuses.IDLE
  }
})

export default api => ({
  state: initialState,

  getters: {
    profileMe: state => state.profiles[state.me],
    profile: state => id => state.profiles[id],
    profiles: state => state.profiles,

    teamProfiles: (state, getters) => teamId => {
      const team = getters.team(teamId)
      const profiles = {}
      if (team) {
        team.members.forEach(member => {
          profiles[member.profile] = state.profiles[member.profile]
        })
      }
      return profiles
    },

    allUserThanks: state => state.thanks,
    userThanksLoading: state => state.meta.thanksLoading,
    isUserThanksLoading: state => state.meta.thanksLoading === statuses.LOADING,
    userThanks: state => id => state.thanks[id]
  },

  mutations: {
    updateProfile: (state, profile) => {
      state.profiles[profile.id] = { ...(state.profiles[profile.id || {}]), ...profile }
    },

    updateProfileMe: (state, profile) => {
      state.profiles[profile.id] = { ...(state.profiles[profile.id || {}]), ...profile }
      state.me = profile.id
    },

    updateProfiles: (state, profiles) => {
      state.profiles = { ...state.profiles, ...profiles }
    },

    fetchUserThanks: state => {
      state.meta.thanksLoading = statuses.LOADING
    },

    fetchUserThanksSuccess: (state, { id, thanks }) => {
      state.meta.thanksLoading = statuses.LOADED
      state.thanks = { ...state.thanks, [id]: thanks }
    },

    fetchUserThanksFailure: (state, error) => {
      state.meta.thanksLoading = statuses.FAILED
    },

    resetProfiles: state => {
      const payload = initialState()
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },

  actions: {
    fetchProfile: async ({ commit }, id) => {
      const result = await api.fetchProfile(id)
      commit('updateProfile', result)
    },

    fetchProfileMe: async ({ commit }) => {
      const result = await api.fetchProfileMe()
      commit('updateProfileMe', result)
    },

    updateProfile: async ({ commit }, { id, data }) => {
      const result = await api.updateProfile(id, data)
      commit('updateProfile', result)
    },

    updateProfileMe: async ({ commit }, data) => {
      const result = await api.updateProfileMe(data)
      commit('updateProfileMe', result)
    },

    fetchUserThanks: async ({ commit }, profileId) => {
      const slug = api.getWorkspaceSlug()
      commit('fetchUserThanks')
      try {
        const thanks = await api.fetchUserThanks(slug, profileId)
        commit('fetchUserThanksSuccess', { id: profileId, thanks })
      } catch (error) {
        commit('fetchUserThanksFailure', error)
      }
    },

    changePassword: async ({ commit }, { oldPassword, newPassword }) => {
      await api.changePassword(oldPassword, newPassword, newPassword)
    },

    clear: ({ commit }) => {
      commit('resetProfiles')
    }
  }
})
